var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recommended-links-wrapper" }, [
    _vm.isLoading
      ? _c("div", { staticClass: "pt-5" }, [_c("loading-spinner-small")], 1)
      : _c("div", [
          _c("div", { staticClass: "msg-wrapper" }, [
            _c("div", { staticClass: "success-msg float-right" }, [
              _vm._v(_vm._s(_vm.successMsg))
            ])
          ]),
          _vm._v(" "),
          _vm.isErrored
            ? _c("div", { staticClass: "alert alert-error" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rec-links-search-wrapper" },
            [
              _c("search-small", {
                attrs: { placeholder: "Search recommended bookmarks" },
                on: {
                  "on-keyup": _vm.handleSearch,
                  "on-enter": _vm.handleSearch
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v("Recommended bookmarks")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sub-title pb-1" }, [
            _vm._v("Based on your org and role")
          ]),
          _vm._v(" "),
          _c("table", { key: _vm.tableKey }, [
            _c(
              "tbody",
              [
                _vm._l(_vm.formattedRecommendations, function(recommendation) {
                  return _c("tr", { key: recommendation.fields.URL.Url }, [
                    _c(
                      "td",
                      {
                        staticClass: "first-column",
                        staticStyle: { width: "80%" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(recommendation.fields.Title) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { width: "10%", "text-align": "right" } },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: recommendation.fields.URL.Url,
                              target: _vm.getBookmarkTarget(
                                recommendation.fields.URL.Url
                              )
                            }
                          },
                          [_vm._v("\n              View\n            ")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "add-bookmark-column",
                        on: {
                          click: function($event) {
                            return _vm.handleSaveBookmark(recommendation)
                          }
                        }
                      },
                      [_vm._m(0, true)]
                    )
                  ])
                }),
                _vm._v(" "),
                _vm.filteredRecommendations.length === 0
                  ? _c("tr", { staticClass: "no-recommendations-text" }, [
                      _c("td", [
                        _vm._v(
                          "\n            No recommended bookmarks for you at this time. Check back again later.\n          "
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.displayShowMore
            ? _c("div", { staticClass: "mt-2 float-right" }, [
                _c("a", { on: { click: _vm.handleShowMore } }, [
                  _vm._v("Show more")
                ])
              ])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "add-text" }, [
      _c("div", { staticClass: "add-icon d-inline-block" }),
      _vm._v(" "),
      _c("div", { staticClass: "d-inline-block" }, [_vm._v("Add")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a98ce022", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a98ce022","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/bookmarks/RecommendedLinks.vue
// module id = null
// module chunks = 